'use strict';

var ServiceDemandDateRangeFilterFactory = function ServiceDemandDateRangeFilterFactory(DataRangeFilter) {
  function ServiceDemandDateRangeFilter() {
    DataRangeFilter.call(this, 'service', 'dateRange', 1);
  }
  ServiceDemandDateRangeFilter.constructor = ServiceDemandDateRangeFilter;
  ServiceDemandDateRangeFilter.prototype = Object.create(DataRangeFilter.prototype);
  ServiceDemandDateRangeFilter.prototype.groupBy = 'departureDateMoment';
  ServiceDemandDateRangeFilter.prototype.filterGroup = function (dateRange) {
    return function (departureDate) {
      for (var i = 0, len = dateRange.length; i < len; ++i) {
        var val = dateRange[i];
        if (!departureDate.isBefore(val.from, 'day') && !departureDate.isAfter(val.to, 'day')) {
          return true;
        }
      }
      return false;
    };
  };
  return ServiceDemandDateRangeFilter;
};
ServiceDemandDateRangeFilterFactory.$inject = ['DataRangeFilterFactory'];
module.exports = ServiceDemandDateRangeFilterFactory;